<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'recaudo-rentas', title: '10.1 Procesos de recaudo de rentas locales' },
  { id: 'tarifas-ica', title: '10.2 Tarifas de liquidación del Impuesto ICA' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="10. Información tributaria en entidades territoriales locales" />
</template>
